<template>
  <m-tab-bar
    v-bind="$attrs"
    class="tabs"
    v-on="$listeners">
    <m-tab
      v-for="tab in tabs"
      :key="tab.title"
      v-model="alwaysActive"
      :href="tab.title"
      :min-width="true">
      <m-icon
        v-if="tab.icon"
        slot="icon"
        :icon="tab.icon" />
      {{ tab.title }}
    </m-tab>
  </m-tab-bar>
</template>

<script>
import Vue from 'vue'
import Tabs from 'material-components-vue/dist/tabs'

Vue.use(Tabs)

export default {
  props: {
    tabs: {
      required: true,
      type: Array
    }
  },
  data () {
    return {
      alwaysActive: true
    }
  }
}
</script>

<style lang="scss">
  @import '../../universal/vars.scss';
  @import "material-components-vue/dist/tabs/styles";
  .tabs .mdc-tab .mdc-tab__text-label {
    color: $mdc-theme-secondary;
    text-transform: none;
  }
  .tabs .mdc-tab-indicator .mdc-tab-indicator__content--underline {
    border-color: $mdc-theme-secondary;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }
</style>
